import React from "react";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

const Footer = () => {
    const { getFontSize } = useResponsiveStyles();
    return (
        <div className="flex flex-col justify-center ml-3 mb-2 gap-1">
            <div
                className="flex items-center gap-1 text-[#939598]"
                style={{ ...getFontSize("body1") }}
            >
                <img
                    src="/icons/copyright.svg"
                    alt="Copyright"
                    className="w-5 h-5"
                />
                support@ambit.co
            </div>
            <div
                className="text-[#939598] ml-1"
                style={{ ...getFontSize("body1") }}
            >
                © Copyright 2024 by Ambit
            </div>
        </div>
    );
};

export default Footer;
